import _stringTrim from "../internals/string-trim";
import _stringTrimForced from "../internals/string-trim-forced";
var exports = {};
var $trimStart = _stringTrim.start;
var forcedStringTrimMethod = _stringTrimForced;

// `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
exports = forcedStringTrimMethod("trimStart") ? function trimStart() {
  return $trimStart(this);
  // eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : "".trimStart;
export default exports;